export const COUNTRIES = [
	{
		code: 'CA',
		countryCode: '1',
		name: 'Canada',
		nativeSpelling: 'Canada',
		de: 'Kanada',
		es: 'Canadá',
		pt: 'Canadá',
		'zh-hant': '加拿大',
		zh: '加拿大',
	},
	{
		code: 'MX',
		countryCode: '52',
		name: 'Mexico',
		nativeSpelling: 'Mexico',
		de: 'Mexiko',
		fr: 'Mexique',
		es: 'México',
		pt: 'México',
		'zh-hant': '墨西哥',
		zh: '墨西哥',
	},
	{
		code: 'US',
		countryCode: '1',
		name: 'United States',
		nativeSpelling: 'United States',
		de: 'Vereinigte Staaten',
		fr: 'États-Unis',
		nl: 'Verenigde Staten',
		es: 'Estados Unidos',
		pt: 'Estados Unidos',
		'zh-hant': '美國',
		zh: '美国',
	},
	{
		code: 'GB',
		countryCode: '44',
		name: 'United Kingdom',
		nativeSpelling: 'United Kingdom',
		de: 'Vereinigtes Königreich',
		fr: 'Royaume-Uni',
		nl: 'Verenigd Koninkrijk',
		es: 'Reino Unido',
		pt: 'Reino Unido',
		'zh-hant': '英國',
		zh: '英国',
	},
	{
		code: 'AF',
		countryCode: '93',
		name: 'Afghanistan',
		nativeSpelling: 'Afghanestan',
		de: 'Afghanistan',
		es: 'Afganistán',
		pt: 'Afeganistão',
		'zh-hant': '阿富汗',
		zh: '阿富汗',
	},
	{
		code: 'AL',
		countryCode: '355',
		name: 'Albania',
		nativeSpelling: 'Shqiperia',
		de: 'Albanien',
		fr: 'Albanie',
		nl: 'Albanië',
		es: 'Albania',
		pt: 'Albânia',
		'zh-hant': '阿爾巴尼亞',
		zh: '阿尔巴尼亚',
	},
	{
		code: 'NF',
		countryCode: '672',
		name: 'Norfolk Island',
		nativeSpelling: 'Norfolk Island',
		fr: 'Norfolk (île)',
		de: 'Norfolkinsel',
		es: 'Isla Norfolk',
		pt: 'Ilha Norfolk',
		'zh-hant': '諾福克島',
		zh: '诺福克岛',
	},
	{
		code: 'DZ',
		countryCode: '213',
		name: 'Algeria',
		nativeSpelling: 'Al Jaza"ir',
		de: 'Algerien',
		fr: 'Algérie',
		nl: 'Algerije',
		es: 'Argelia',
		pt: 'Argélia',
		'zh-hant': '阿爾及利亞',
		zh: '阿尔及利亚',
	},
	{
		code: 'MP',
		countryCode: '1',
		name: 'Northern Mariana Islands',
		nativeSpelling: 'Commonwealth of The Northern Mariana Islands',
		de: 'Nördliche Marianen',
		fr: 'Mariannes du Nord (îles)',
		nl: 'Noordelijke Marianen',
		es: 'Islas Marianas del Norte',
		pt: 'Ilhas Marianas do Norte',
		'zh-hant': '北馬利安納群島',
		zh: '北马里亚纳群岛',
	},
	{
		code: 'AD',
		countryCode: '376',
		name: 'Andorra',
		nativeSpelling: 'Andorra',
		fr: 'Andorre',
		de: 'Andorra',
		es: 'Andorra',
		pt: 'Andorra',
		'zh-hant': '安道爾',
		zh: '安道尔',
	},
	{
		code: 'AI',
		countryCode: '1',
		name: 'Anguilla',
		nativeSpelling: 'Anguilla',
		de: 'Anguilla',
		es: 'Anguila',
		pt: 'Anguilla',
		'zh-hant': '安奎拉',
		zh: '安圭拉',
	},
	{
		code: 'AO',
		countryCode: '244',
		name: 'Angola',
		nativeSpelling: 'Angola',
		de: 'Angola',
		es: 'Angola',
		pt: 'Angola',
		'zh-hant': '安哥拉',
		zh: '安哥拉',
	},
	{
		code: 'AG',
		countryCode: '1',
		name: 'Antigua and Barbuda',
		nativeSpelling: 'Antigua and Barbuda',
		de: 'Antigua und Barbuda',
		fr: 'Antigua-et-Barbuda',
		es: 'Antigua y Barbuda',
		pt: 'Antígua e Barbuda',
		'zh-hant': '安提瓜和巴布達',
		zh: '安提瓜和巴布达',
	},
	{
		code: 'AR',
		countryCode: '54',
		name: 'Argentina',
		nativeSpelling: 'Argentina',
		de: 'Argentinien',
		fr: 'Argentine',
		nl: 'Argentinië',
		es: 'Argentina',
		pt: 'Argentina',
		'zh-hant': '阿根廷',
		zh: '阿根廷',
	},
	{
		code: 'AM',
		countryCode: '374',
		name: 'Armenia',
		nativeSpelling: 'Hayastan',
		de: 'Armenien',
		fr: 'Arménie',
		nl: 'Armenië',
		es: 'Armenia',
		pt: 'Armênia',
		'zh-hant': '亞美尼亞',
		zh: '亚美尼亚',
	},
	{
		code: 'AU',
		countryCode: '61',
		name: 'Australia',
		nativeSpelling: 'Australia',
		de: 'Australien',
		fr: 'Australie',
		nl: 'Australië',
		es: 'Australia',
		pt: 'Austrália',
		'zh-hant': '澳洲',
		zh: '澳大利亚',
	},
	{
		code: 'AW',
		countryCode: '297',
		name: 'Aruba',
		nativeSpelling: 'Aruba',
		de: 'Aruba',
		es: 'Aruba',
		pt: 'Aruba',
		'zh-hant': '阿魯巴',
		zh: '阿鲁巴',
	},
	{
		code: 'AT',
		countryCode: '43',
		name: 'Austria',
		nativeSpelling: 'Oesterreich',
		de: 'Österreich',
		nl: 'Oostenrijk',
		es: 'Austria',
		pt: 'Áustria',
		'zh-hant': '奧地利',
		zh: '奥地利',
	},
	{
		code: 'AZ',
		countryCode: '994',
		name: 'Azerbaijan',
		nativeSpelling: 'Azarbaycan Respublikasi',
		de: 'Aserbaidschan',
		fr: 'Azerbaïdjan',
		nl: 'Azerbeidzjan',
		es: 'Azerbaiyán',
		pt: 'Azerbaijão',
		'zh-hant': '阿塞拜疆',
		zh: '阿塞拜疆',
	},
	{
		code: 'BS',
		countryCode: '1',
		name: 'Bahamas',
		nativeSpelling: 'The Bahamas',
		de: 'Bahamas',
		es: 'Bahamas',
		pt: 'Bahamas',
		'zh-hant': '巴哈馬',
		zh: '巴哈马',
	},
	{
		code: 'BH',
		countryCode: '973',
		name: 'Bahrain',
		nativeSpelling: 'Al Bahrayn',
		fr: 'Bahreïn',
		nl: 'Bahrein',
		de: 'Bahrain',
		es: 'Bahréin',
		pt: 'Bahrain',
		'zh-hant': '巴林',
		zh: '巴林',
	},
	{
		code: 'BD',
		countryCode: '880',
		name: 'Bangladesh',
		nativeSpelling: 'Bangladesh',
		de: 'Bangladesch',
		es: 'Bangladesh',
		pt: 'Bangladesh',
		'zh-hant': '孟加拉',
		zh: '孟加拉国',
	},
	{
		code: 'BB',
		countryCode: '1',
		name: 'Barbados',
		nativeSpelling: 'Barbados',
		fr: 'Barbade',
		de: 'Barbados',
		es: 'Barbados',
		pt: 'Barbados',
		'zh-hant': '巴巴多斯',
		zh: '巴巴多斯',
	},
	{
		code: 'BY',
		countryCode: '375',
		name: 'Belarus',
		nativeSpelling: 'Byelarus',
		de: 'Weißrussland',
		fr: 'Biélorussie',
		es: 'Bielorrusia',
		pt: 'Belarus',
		'zh-hant': '白俄羅斯',
		zh: '白俄罗斯',
	},
	{
		code: 'BE',
		countryCode: '32',
		name: 'Belgium',
		nativeSpelling: 'Belgique (French) or Belgie (Flemish)',
		fr: 'Belgique',
		de: 'Belgium',
		nl: 'België',
		es: 'Bélgica',
		pt: 'Bélgica',
		'zh-hant': '比利時',
		zh: '比利时',
	},
	{
		code: 'BZ',
		countryCode: '501',
		name: 'Belize',
		nativeSpelling: 'Belice',
		de: 'Belize',
		es: 'Belice',
		pt: 'Belize',
		'zh-hant': '伯利茲',
		zh: '伯利兹',
	},
	{
		code: 'BJ',
		countryCode: '229',
		name: 'Benin',
		nativeSpelling: 'Benin',
		fr: 'Bénin',
		de: 'Benin',
		es: 'Benín',
		pt: 'Benin',
		'zh-hant': '貝寧',
		zh: '贝宁',
	},
	{
		code: 'BM',
		countryCode: '1',
		name: 'Bermuda',
		nativeSpelling: 'Bermuda',
		fr: 'Bermudes',
		de: 'Bermuda',
		es: 'Bermudas',
		pt: 'Bermudas',
		'zh-hant': '百慕達',
		zh: '百慕大',
	},
	{
		code: 'BT',
		countryCode: '975',
		name: 'Bhutan',
		nativeSpelling: 'Drukyul',
		fr: 'Bhoutan',
		de: 'Bhutan',
		es: 'Bután',
		pt: 'Butão',
		'zh-hant': '不丹',
		zh: '不丹',
	},
	{
		code: 'BO',
		countryCode: '591',
		name: 'Bolivia',
		nativeSpelling: 'Bolivia, Plurinational State of',
		de: 'Bolivien',
		fr: 'Bolivie',
		es: 'Bolivia',
		pt: 'Bolívia',
		'zh-hant': '玻利維亞',
		zh: '玻利维亚',
	},
	{
		code: 'BQ',
		countryCode: '599',
		name: 'Bonaire, Sint Eustatius, and Saba',
		de: 'Bonaire',
		es: 'Caribe neerlandés',
		pt: 'BQ',
		'zh-hant': '荷蘭加勒比區',
		zh: '荷属加勒比区',
	},
	{
		code: 'BA',
		countryCode: '387',
		name: 'Bosnia and Herzegovina',
		nativeSpelling: 'Bosna i Hercegovina',
		de: 'Bosnien und Herzegowina',
		fr: 'Bosnie-Herzégovine',
		nl: 'Bosnië en Herzegovina',
		es: 'Bosnia-Herzegovina',
		pt: 'Bósnia-Herzegovina',
		'zh-hant': '波斯尼亞和黑塞哥維那',
		zh: '波斯尼亚和黑塞哥维那',
	},
	{
		code: 'BW',
		countryCode: '267',
		name: 'Botswana',
		nativeSpelling: 'Botswana',
		de: 'Botsuana',
		es: 'Botsuana',
		pt: 'Botsuana',
		'zh-hant': '博茨瓦納',
		zh: '博茨瓦纳',
	},
	{
		code: 'BV',
		countryCode: '55',
		name: 'Bouvet Island',
		nativeSpelling: 'Bouvet Island',
		de: 'Bouvetinsel',
		fr: 'Bouvet (île)',
		nl: 'Bouveteiland',
		es: 'Isla Bouvet',
		pt: 'Ilha Bouvet',
		'zh-hant': '鮑威特島',
		zh: '布韦岛',
	},
	{
		code: 'BR',
		countryCode: '55',
		name: 'Brazil',
		nativeSpelling: 'Brasil',
		de: 'Brasilien',
		fr: 'Brésil',
		nl: 'Brazilië',
		es: 'Brasil',
		pt: 'Brasil',
		'zh-hant': '巴西',
		zh: '巴西',
	},
	{
		code: 'IO',
		countryCode: '246',
		name: 'British Indian Ocean Territory',
		nativeSpelling: 'British Indian Ocean Territory',
		de: 'Britisches Territorium im Indischen Ozean',
		fr: "Territoires britanniques de l'Océan Indien",
		nl: 'Brits Indische Oceaanterritorium',
		es: 'Territorio Británico del Océano Índico',
		pt: 'Território Britânico do Oceano Índico',
		'zh-hant': '英屬印度洋領地',
		zh: '英属印度洋领地',
	},
	{
		code: 'VG',
		countryCode: '1',
		name: 'British Virgin Islands',
		nativeSpelling: 'British Virgin Islands',
		de: 'Jungferninseln (Britisch)',
		fr: 'Vierges britanniques (îles)',
		nl: 'Britse Maagdeneilanden',
		es: 'Islas Vírgenes Británicas',
		pt: 'Ilhas Virgens Britânicas',
		'zh-hant': '英屬維爾京群島',
		zh: '英属维尔京群岛',
	},
	{
		code: 'VI',
		countryCode: '1',
		name: 'U.S. Virgin Islands',
		nativeSpelling: 'United States Virgin Islands',
		de: 'Jungferninseln (Amerikanisch)',
		nl: 'Amerikaanse Maagdeneilanden',
		es: 'Islas Vírgenes de los Estados Unidos',
		pt: 'Ilhas Virgens dos EUA',
		'zh-hant': '美屬維爾京群島',
		zh: '美属维尔京群岛',
	},
	{
		code: 'WF',
		countryCode: '681',
		name: 'Wallis and Futuna',
		nativeSpelling: 'Collectivity of the Wallis and Futuna Islands',
		de: 'Wallis und Futuna',
		fr: 'Wallis-et-Futuna (îles)',
		nl: 'Wallis en Futuna',
		es: 'Wallis y Futuna',
		pt: 'Wallis e Futuna',
		'zh-hant': '瓦利斯群島和富圖那群島',
		zh: '瓦利斯和富图纳',
	},
	{
		code: 'BN',
		countryCode: '673',
		name: 'Brunei',
		nativeSpelling: 'Brunei',
		de: 'Brunei Darussalam',
		nl: 'Brunei Darussalam',
		es: 'Brunéi',
		pt: 'Brunei',
		'zh-hant': '汶萊',
		zh: '文莱',
	},
	{
		code: 'BG',
		countryCode: '359',
		name: 'Bulgaria',
		nativeSpelling: 'Republika Bulgariya',
		de: 'Bulgarien',
		fr: 'Bulgarie',
		nl: 'Bulgarije',
		es: 'Bulgaria',
		pt: 'Bulgária',
		'zh-hant': '保加利亞',
		zh: '保加利亚',
	},
	{
		code: 'BF',
		countryCode: '226',
		name: 'Burkina Faso',
		nativeSpelling: 'Burkina Faso',
		fr: 'Burkina Faso',
		de: 'Burkina Faso',
		es: 'Burkina Faso',
		pt: 'Burquina Faso',
		'zh-hant': '布基納法索',
		zh: '布基纳法索',
	},
	{
		code: 'BI',
		countryCode: '257',
		name: 'Burundi',
		nativeSpelling: 'Burundi',
		de: 'Burundi',
		es: 'Burundi',
		pt: 'Burundi',
		'zh-hant': '布隆迪',
		zh: '布隆迪',
	},
	{
		code: 'KH',
		countryCode: '855',
		name: 'Cambodia',
		nativeSpelling: 'Kampuchea',
		de: 'Kambodscha',
		fr: 'Cambodge',
		nl: 'Cambodja',
		es: 'Camboya',
		pt: 'Camboja',
		'zh-hant': '柬埔寨',
		zh: '柬埔寨',
	},
	{
		code: 'CM',
		countryCode: '237',
		name: 'Cameroon',
		nativeSpelling: 'Cameroon or Cameroun (French)',
		fr: 'Cameroun',
		de: 'Kamerun',
		nl: 'Kameroen',
		es: 'Camerún',
		pt: 'República dos Camarões',
		'zh-hant': '喀麥隆',
		zh: '喀麦隆',
	},
	{
		code: 'CV',
		countryCode: '238',
		name: 'Cape Verde',
		nativeSpelling: 'Cabo Verde',
		de: 'Kap Verde',
		fr: 'Cap-Vert',
		nl: 'Kaapverdië',
		es: 'Cabo Verde',
		pt: 'Cabo Verde',
		'zh-hant': '佛得角',
		zh: '佛得角',
	},
	{
		code: 'KY',
		countryCode: '1',
		name: 'Cayman Islands',
		nativeSpelling: 'Cayman Islands',
		de: 'Kaimaninseln',
		fr: 'Caïmans (îles)',
		nl: 'Kaaimaneilanden',
		es: 'Islas Caimán',
		pt: 'Ilhas Caiman',
		'zh-hant': '開曼群島',
		zh: '开曼群岛',
	},
	{
		code: 'CF',
		countryCode: '236',
		name: 'Central African Republic',
		nativeSpelling: 'Republique Centrafricaine',
		de: 'Zentralafrikanische Republik',
		fr: 'République centrafricaine',
		nl: 'Centraal-Afrikaanse Republiek',
		es: 'República Centroafricana',
		pt: 'República Centro-Africana',
		'zh-hant': '中非共和國',
		zh: '中非共和国',
	},
	{
		code: 'TD',
		countryCode: '235',
		name: 'Chad',
		nativeSpelling: 'Tchad',
		de: 'Tschad',
		fr: 'Tchad',
		nl: 'Tsjaad',
		es: 'Chad',
		pt: 'Chade',
		'zh-hant': '乍得',
		zh: '乍得',
	},
	{
		code: 'CL',
		countryCode: '56',
		name: 'Chile',
		nativeSpelling: 'Chile',
		fr: 'Chili',
		nl: 'Chili',
		de: 'Chile',
		es: 'Chile',
		pt: 'Chile',
		'zh-hant': '智利',
		zh: '智利',
	},
	{
		code: 'CN',
		countryCode: '86',
		name: 'China',
		nativeSpelling: 'Zhong Guo',
		fr: 'Chine',
		de: 'China',
		es: 'China',
		pt: 'China',
		'zh-hant': '中國',
		zh: '中国',
	},
	{
		code: 'CX',
		countryCode: '61',
		name: 'Christmas Island',
		nativeSpelling: 'Territory of Christmas Island',
		de: 'Weihnachtsinsel',
		fr: 'Christmas (île)',
		nl: 'Christmaseiland',
		es: 'Isla Christmas',
		pt: 'Ilhas Natal',
		'zh-hant': '聖誕島',
		zh: '圣诞岛',
	},
	{
		code: 'CC',
		countryCode: '891',
		name: 'Cocos (Keeling) Islands',
		nativeSpelling: 'Territory of Cocos (Keeling) Islands',
		de: 'Kokosinseln',
		fr: 'Cocos-Keeling (îles)',
		nl: 'Cocoseilanden (Keelingeilanden)',
		es: 'Islas Cocos',
		pt: 'Ilhas Coco',
		'zh-hant': '可可斯群島',
		zh: '科科斯（基林）群岛',
	},
	{
		code: 'CO',
		countryCode: '57',
		name: 'Colombia',
		nativeSpelling: 'Colombia',
		de: 'Kolumbien',
		fr: 'Colombie',
		es: 'Colombia',
		pt: 'Colômbia',
		'zh-hant': '哥倫比亞',
		zh: '哥伦比亚',
	},
	{
		code: 'KM',
		countryCode: '269',
		name: 'Comoros',
		nativeSpelling: 'Comores',
		de: 'Komoren',
		fr: 'Comores',
		nl: 'Comoren',
		es: 'Comoras',
		pt: 'Comores',
		'zh-hant': '科摩羅',
		zh: '科摩罗',
	},
	{
		code: 'CG',
		countryCode: '242',
		name: 'Congo, Republic of the',
		nativeSpelling: 'Republique du Congo',
		de: 'Kongo',
		es: 'Congo - Brazzaville',
		pt: 'Congo - Brazzaville',
		'zh-hant': '剛果（布拉薩）',
		zh: '刚果（布）',
	},
	{
		code: 'CD',
		countryCode: '243',
		name: 'Congo, Democratic Republic of the',
		nativeSpelling: 'Republique Democratique du Congo',
		de: 'Kongo, Demokratische Republik',
		fr: 'Congo, République démocratique du',
		nl: 'Congo, Democratische Republiek',
		es: 'República Democrática del Congo',
		pt: 'Congo-Kinshasa',
		'zh-hant': '剛果（金夏沙）',
		zh: '刚果（金）',
	},
	{
		code: 'CK',
		countryCode: '682',
		name: 'Cook Islands',
		nativeSpelling: 'Cook Islands',
		de: 'Cookinseln',
		fr: 'Cook (îles)',
		nl: 'Cookeilanden',
		es: 'Islas Cook',
		pt: 'Ilhas Cook',
		'zh-hant': '庫克群島',
		zh: '库克群岛',
	},
	{
		code: 'CR',
		countryCode: '506',
		name: 'Costa Rica',
		nativeSpelling: 'Costa Rica',
		de: 'Costa Rica',
		es: 'Costa Rica',
		pt: 'Costa Rica',
		'zh-hant': '哥斯達黎加',
		zh: '哥斯达黎加',
	},
	{
		code: 'CI',
		countryCode: '225',
		name: "Cote d'Ivoire (Ivory Coast)",
		nativeSpelling: "Republic of Cote d'Ivoire",
		de: "Côte d'Ivoire",
		nl: 'Ivoorkust',
		es: 'Costa de Marfil',
		pt: 'Costa do Marfim',
		'zh-hant': '科特迪瓦',
		zh: '科特迪瓦',
	},
	{
		code: 'HR',
		countryCode: '385',
		name: 'Croatia',
		nativeSpelling: 'Hrvatska',
		de: 'Kroatien',
		fr: 'Croatie',
		nl: 'Kroatië',
		es: 'Croacia',
		pt: 'Croácia',
		'zh-hant': '克羅地亞',
		zh: '克罗地亚',
	},
	{
		code: 'CU',
		countryCode: '53',
		name: 'Cuba',
		nativeSpelling: 'Cuba',
		de: 'Kuba',
		es: 'Cuba',
		pt: 'Cuba',
		'zh-hant': '古巴',
		zh: '古巴',
	},
	{
		code: 'CY',
		countryCode: '357',
		name: 'Cyprus',
		nativeSpelling: 'Kypros (Greek) or Kibris (Turkish)',
		gr: 'Kypros',
		tr: 'Kibris',
		de: 'Zypern',
		fr: 'Chypre',
		es: 'Chipre',
		pt: 'Chipre',
		'zh-hant': '塞浦路斯',
		zh: '塞浦路斯',
	},
	{
		code: 'CZ',
		countryCode: '420',
		name: 'Czech Republic',
		nativeSpelling: 'Ceska Republika',
		de: 'Tschechische Republik',
		fr: 'République tchèque',
		nl: 'Tsjechië',
		es: 'República Checa',
		pt: 'República Tcheca',
		'zh-hant': '捷克',
		zh: '捷克',
	},
	{
		code: 'DK',
		countryCode: '45',
		name: 'Denmark',
		nativeSpelling: 'Danmark',
		de: 'Dänemark',
		fr: 'Danemark',
		nl: 'Denemarken',
		es: 'Dinamarca',
		pt: 'Dinamarca',
		'zh-hant': '丹麥',
		zh: '丹麦',
	},
	{
		code: 'DJ',
		countryCode: '253',
		name: 'Djibouti',
		nativeSpelling: 'Djibouti',
		de: 'Dschibuti',
		es: 'Yibuti',
		pt: 'Djibuti',
		'zh-hant': '吉布提',
		zh: '吉布提',
	},
	{
		code: 'DM',
		countryCode: '1',
		name: 'Dominica',
		nativeSpelling: 'Dominica',
		nl: 'Dominica',
		de: 'Dominica',
		es: 'Dominica',
		pt: 'Dominica',
		'zh-hant': '多米尼克',
		zh: '多米尼克',
	},
	{
		code: 'DO',
		countryCode: '1',
		name: 'Dominican Republic',
		nativeSpelling: 'Republica Dominicana',
		de: 'Dominikanische Republik',
		fr: 'République dominicaine',
		nl: 'Dominicaanse Republiek',
		es: 'República Dominicana',
		pt: 'República Dominicana',
		'zh-hant': '多明尼加共和國',
		zh: '多米尼加共和国',
	},
	{
		code: 'TL',
		countryCode: '670',
		name: 'Timor-Leste',
		nativeSpelling: 'Democratic Republic of Timor-Leste',
		de: 'Timor-Leste',
		fr: 'Timor-Oriental',
		nl: 'Oost-Timor',
		es: 'Timor Oriental',
		pt: 'Timor-Leste',
		'zh-hant': '東帝汶',
		zh: '东帝汶',
	},
	{
		code: 'EC',
		countryCode: '593',
		name: 'Ecuador',
		nativeSpelling: 'Ecuador',
		fr: 'Équateur',
		de: 'Ecuador',
		es: 'Ecuador',
		pt: 'Equador',
		'zh-hant': '厄瓜多爾',
		zh: '厄瓜多尔',
	},
	{
		code: 'EG',
		countryCode: '20',
		name: 'Egypt',
		nativeSpelling: 'Misr',
		de: 'Ägypten',
		fr: 'Égypte',
		nl: 'Egypte',
		es: 'Egipto',
		pt: 'Egito',
		'zh-hant': '埃及',
		zh: '埃及',
	},
	{
		code: 'SV',
		countryCode: '503',
		name: 'El Salvador',
		nativeSpelling: 'El Salvador',
		de: 'El Salvador',
		es: 'El Salvador',
		pt: 'El Salvador',
		'zh-hant': '薩爾瓦多',
		zh: '萨尔瓦多',
	},
	{
		code: 'GQ',
		countryCode: '240',
		name: 'Equatorial Guinea',
		nativeSpelling: 'Guinea Ecuatorial',
		de: 'Äquatorialguinea',
		fr: 'Guinée équatoriale',
		nl: 'Equatoriaal-Guinea',
		es: 'Guinea Ecuatorial',
		pt: 'Guiné Equatorial',
		'zh-hant': '赤道幾內亞',
		zh: '赤道几内亚',
	},
	{
		code: 'ER',
		countryCode: '291',
		name: 'Eritrea',
		nativeSpelling: 'Ertra',
		fr: 'Érythrée',
		de: 'Eritrea',
		es: 'Eritrea',
		pt: 'Eritreia',
		'zh-hant': '厄立特里亞',
		zh: '厄立特里亚',
	},
	{
		code: 'EE',
		countryCode: '372',
		name: 'Estonia',
		nativeSpelling: 'Eesti',
		de: 'Estland',
		fr: 'Estonie',
		nl: 'Estland',
		es: 'Estonia',
		pt: 'Estônia',
		'zh-hant': '愛沙尼亞',
		zh: '爱沙尼亚',
	},
	{
		code: 'ET',
		countryCode: '251',
		name: 'Ethiopia',
		nativeSpelling: 'YeItyop"iya',
		de: 'Äthiopien',
		fr: 'Éthiopie',
		nl: 'Ethiopië',
		es: 'Etiopía',
		pt: 'Etiópia',
		'zh-hant': '埃塞俄比亞',
		zh: '埃塞俄比亚',
	},
	{
		code: 'FJ',
		countryCode: '679',
		name: 'Fiji',
		nativeSpelling: 'Fiji',
		de: 'Fidschi',
		fr: 'Fidji',
		es: 'Fiyi',
		pt: 'Fiji',
		'zh-hant': '斐濟',
		zh: '斐济',
	},
	{
		code: 'FK',
		countryCode: '500',
		name: 'Falkland Islands',
		nativeSpelling: 'Falkland Islands',
		de: 'Falklandinseln (Malwinen)',
		fr: 'Falkland (îles Falkland ou Malouines)',
		nl: 'Falklandeilanden (Malvinas)',
		es: 'Islas Malvinas',
		pt: 'Ilhas Malvinas',
		'zh-hant': '福克蘭群島',
		zh: '福克兰群岛',
	},
	{
		code: 'FO',
		countryCode: '298',
		name: 'Faroe Islands',
		nativeSpelling: 'Faroe Islands',
		de: 'Färöer',
		fr: 'Féroé (îles)',
		nl: 'Faeröer',
		es: 'Islas Feroe',
		pt: 'Ilhas Faroe',
		'zh-hant': '法羅群島',
		zh: '法罗群岛',
	},
	{
		code: 'FI',
		countryCode: '358',
		name: 'Finland',
		nativeSpelling: 'Suomi',
		de: 'Finnland',
		fr: 'Finlande',
		es: 'Finlandia',
		pt: 'Finlândia',
		'zh-hant': '芬蘭',
		zh: '芬兰',
	},
	{
		code: 'FR',
		countryCode: '33',
		name: 'France',
		nativeSpelling: 'France or Republique Francaise',
		de: 'Frankreich',
		nl: 'Frankrijk',
		es: 'Francia',
		pt: 'França',
		'zh-hant': '法國',
		zh: '法国',
	},
	{
		code: 'GF',
		countryCode: '594',
		name: 'French Guiana',
		nativeSpelling: 'Overseas Region of Guiana',
		de: 'Französisch-Guayana',
		fr: 'Guyane française',
		nl: 'Frans-Guyana',
		es: 'Guayana Francesa',
		pt: 'Guiana Francesa',
		'zh-hant': '法屬圭亞那',
		zh: '法属圭亚那',
	},
	{
		code: 'PF',
		countryCode: '689',
		name: 'French Polynesia',
		nativeSpelling: 'Overseas Country of French Polynesia',
		de: 'Französisch-Polynesien',
		fr: 'Polynésie française',
		nl: 'Frans-Polynesië',
		es: 'Polinesia Francesa',
		pt: 'Polinésia Francesa',
		'zh-hant': '法屬波利尼西亞',
		zh: '法属波利尼西亚',
	},
	{
		code: 'TF',
		countryCode: '262',
		name: 'French Southern Territories',
		nativeSpelling: 'Territory of the French Southern and Antarctic Lands',
		de: 'Französische Südgebiete',
		fr: 'Terres Australes françaises',
		nl: 'Franse Zuidelijke Gebieden',
		es: 'Territorios Australes Franceses',
		pt: 'Territórios Franceses do Sul',
		'zh-hant': '法屬南部領地',
		zh: '法属南部领地',
	},
	{
		code: 'GA',
		countryCode: '241',
		name: 'Gabon',
		nativeSpelling: 'Gabon',
		de: 'Gabun',
		es: 'Gabón',
		pt: 'Gabão',
		'zh-hant': '加蓬',
		zh: '加蓬',
	},
	{
		code: 'GM',
		countryCode: '220',
		name: 'Gambia',
		nativeSpelling: 'Gambia',
		fr: 'Gambie',
		de: 'Gambia',
		es: 'Gambia',
		pt: 'Gâmbia',
		'zh-hant': '岡比亞',
		zh: '冈比亚',
	},
	{
		code: 'GE',
		countryCode: '995',
		name: 'Georgia',
		nativeSpelling: 'Sak"art"velo',
		de: 'Georgien',
		fr: 'Géorgie',
		nl: 'Georgië',
		es: 'Georgia',
		pt: 'Geórgia',
		'zh-hant': '格魯吉亞',
		zh: '格鲁吉亚',
	},
	{
		code: 'GS',
		countryCode: '500',
		name: 'South Georgia and the South Sandwich Islands',
		nativeSpelling: 'SGSSI',
		de: 'Südgeorgien, Südliche Sandwichinseln',
		fr: 'Géorgie du Sud, Îles Sandwich',
		nl: 'Zuid-Georgia, en de Zuidelijke Sandwicheilanden',
		es: 'Islas Georgia del Sur y Sandwich del Sur',
		pt: 'Geórgia do Sul e Ilhas Sandwich do Sul',
		'zh-hant': '南佐治亞島與南桑威奇群島',
		zh: '南乔治亚和南桑威奇群岛',
	},
	{
		code: 'DE',
		countryCode: '49',
		name: 'Germany',
		nativeSpelling: 'Deutschland',
		de: 'Deutschland',
		fr: 'Allemagne',
		nl: 'Duitsland',
		es: 'Alemania',
		pt: 'Alemanha',
		'zh-hant': '德國',
		zh: '德国',
	},
	{
		code: 'GH',
		countryCode: '233',
		name: 'Ghana',
		nativeSpelling: 'Ghana',
		de: 'Ghana',
		es: 'Ghana',
		pt: 'Gana',
		'zh-hant': '加納',
		zh: '加纳',
	},
	{
		code: 'GR',
		countryCode: '30',
		name: 'Greece',
		nativeSpelling: 'Ellas',
		de: 'Griechenland',
		fr: 'Grèce',
		nl: 'Griekenland',
		es: 'Grecia',
		pt: 'Grécia',
		'zh-hant': '希臘',
		zh: '希腊',
	},
	{
		code: 'GL',
		countryCode: '299',
		name: 'Greenland',
		nativeSpelling: 'Greenland',
		de: 'Grönland',
		fr: 'Groenland',
		nl: 'Groenland',
		es: 'Groenlandia',
		pt: 'Groênlandia',
		'zh-hant': '格陵蘭',
		zh: '格陵兰',
	},
	{
		code: 'GD',
		countryCode: '1',
		name: 'Grenada',
		nativeSpelling: 'Grenada',
		fr: 'Grenade',
		de: 'Grenada',
		es: 'Granada',
		pt: 'Granada',
		'zh-hant': '格林納達',
		zh: '格林纳达',
	},
	{
		code: 'GT',
		countryCode: '502',
		name: 'Guatemala',
		nativeSpelling: 'Guatemala',
		de: 'Guatemala',
		es: 'Guatemala',
		pt: 'Guatemala',
		'zh-hant': '危地馬拉',
		zh: '危地马拉',
	},
	{
		code: 'GI',
		countryCode: '350',
		name: 'Gibraltar',
		nativeSpelling: 'Gibraltar',
		de: 'Kolonie Gibraltar',
		es: 'Gibraltar',
		pt: 'Gibraltar',
		'zh-hant': '直布羅陀',
		zh: '直布罗陀',
	},
	{
		code: 'GP',
		countryCode: '590',
		name: 'Guadeloupe',
		nativeSpelling: 'Overseas Region of Guadeloupe',
		de: 'Guadeloupe',
		es: 'Guadalupe',
		pt: 'Guadalupe',
		'zh-hant': '瓜地洛普',
		zh: '瓜德罗普',
	},
	{
		code: 'GN',
		countryCode: '224',
		name: 'Guinea',
		nativeSpelling: 'Guinee',
		fr: 'Guinée',
		nl: 'Guinee',
		de: 'Guinea',
		es: 'Guinea',
		pt: 'Guiné',
		'zh-hant': '幾內亞',
		zh: '几内亚',
	},
	{
		code: 'GW',
		countryCode: '245',
		name: 'Guinea-Bissau',
		nativeSpelling: 'Guine-Bissau',
		fr: 'Guinée-Bissau',
		de: 'Guinea-Bissau',
		es: 'Guinea-Bissau',
		pt: 'Guiné Bissau',
		'zh-hant': '幾內亞比紹',
		zh: '几内亚比绍',
	},
	{
		code: 'GY',
		countryCode: '592',
		name: 'Guyana',
		nativeSpelling: 'Guyana',
		de: 'Guyana',
		es: 'Guyana',
		pt: 'Guiana',
		'zh-hant': '圭亞那',
		zh: '圭亚那',
	},
	{
		code: 'HT',
		countryCode: '509',
		name: 'Haiti',
		nativeSpelling: 'Haiti',
		de: 'Haiti',
		es: 'Haití',
		pt: 'Haiti',
		'zh-hant': '海地',
		zh: '海地',
	},
	{
		code: 'HN',
		countryCode: '504',
		name: 'Honduras',
		nativeSpelling: 'Honduras',
		de: 'Honduras',
		es: 'Honduras',
		pt: 'Honduras',
		'zh-hant': '洪都拉斯',
		zh: '洪都拉斯',
	},
	{
		code: 'HM',
		countryCode: '0',
		name: 'Heard Island and McDonald Islands',
		nativeSpelling: 'Territory of Heard Island and McDonald Islands',
		de: 'Heard und McDonaldinseln',
		fr: 'Heard et Mc Donald (îles)',
		nl: 'Heard en McDonaldeilanden',
		es: 'Islas Heard y McDonald',
		pt: 'Ilha Heard e Ilhas McDonald',
		'zh-hant': '赫德島及麥唐納群島',
		zh: '赫德岛和麦克唐纳群岛',
	},
	{
		code: 'HK',
		countryCode: '852',
		name: 'Hong Kong SAR',
		nativeSpelling: 'Hong Kong Special Administrative Region',
		nl: 'Hongkong',
		de: 'Hong Kong SAR',
		es: 'Región Administrativa Especial de Hong Kong de la República Popular China',
		pt: 'Hong Kong, RAE da China',
		'zh-hant': '中國香港特別行政區',
		zh: '中国香港特别行政区',
	},
	{
		code: 'HU',
		countryCode: '36',
		name: 'Hungary',
		nativeSpelling: 'Magyarorszag',
		de: 'Ungarn',
		fr: 'Hongrie',
		nl: 'Hongarije',
		es: 'Hungría',
		pt: 'Hungria',
		'zh-hant': '匈牙利',
		zh: '匈牙利',
	},
	{
		code: 'IS',
		countryCode: '354',
		name: 'Iceland',
		nativeSpelling: 'Island',
		de: 'Island',
		fr: 'Islande',
		nl: 'IJsland',
		es: 'Islandia',
		pt: 'Islândia',
		'zh-hant': '冰島',
		zh: '冰岛',
	},
	{
		code: 'IN',
		countryCode: '91',
		name: 'India',
		nativeSpelling: 'India, Bharat',
		de: 'Indien',
		fr: 'Inde',
		es: 'India',
		pt: 'Índia',
		'zh-hant': '印度',
		zh: '印度',
	},
	{
		code: 'ID',
		countryCode: '62',
		name: 'Indonesia',
		nativeSpelling: 'Indonesia',
		de: 'Indonesien',
		fr: 'Indonésie',
		nl: 'Indonesië',
		es: 'Indonesia',
		pt: 'Indonésia',
		'zh-hant': '印尼',
		zh: '印度尼西亚',
	},
	{
		code: 'IR',
		countryCode: '98',
		name: 'Iran',
		nativeSpelling: 'Iran, Persia',
		de: 'Iran (Islamische Republik)',
		fr: 'Iran (République islamique de)',
		nl: 'Iran (Islamitische Republiek)',
		es: 'Irán',
		pt: 'Irã',
		'zh-hant': '伊朗',
		zh: '伊朗',
	},
	{
		code: 'IQ',
		countryCode: '964',
		name: 'Iraq',
		nativeSpelling: 'Al Iraq',
		de: 'Irak',
		nl: 'Irak',
		es: 'Iraq',
		pt: 'Iraque',
		'zh-hant': '伊拉克',
		zh: '伊拉克',
	},
	{
		code: 'IE',
		countryCode: '353',
		name: 'Ireland',
		nativeSpelling: 'Ireland or Eire',
		de: 'Irland',
		fr: 'Irlande',
		nl: 'Ierland',
		es: 'Irlanda',
		pt: 'Irlanda',
		'zh-hant': '愛爾蘭',
		zh: '爱尔兰',
	},
	{
		code: 'IL',
		countryCode: '972',
		name: 'Israel',
		nativeSpelling: 'Yisra"el',
		fr: 'Israël',
		nl: 'Israël',
		de: 'Israel',
		es: 'Israel',
		pt: 'Israel',
		'zh-hant': '以色列',
		zh: '以色列',
	},
	{
		code: 'UM',
		countryCode: '1',
		name: 'United States Minor Outlying Islands',
		nativeSpelling: 'United States Minor Outlying Islands',
		de: 'Kleinere Amerikanische Überseeinseln ',
		nl: 'Kleine afgelegen eilanden van de Verenigde Staten',
		es: 'Islas menores alejadas de los Estados Unidos',
		pt: 'Ilhas Distantes dos EUA',
		'zh-hant': '美國本土外小島嶼',
		zh: '美国本土外小岛屿',
	},
	{
		code: 'IT',
		countryCode: '39',
		name: 'Italy',
		nativeSpelling: 'Italia',
		de: 'Italien',
		fr: 'Italie',
		nl: 'Italië',
		es: 'Italia',
		pt: 'Itália',
		'zh-hant': '意大利',
		zh: '意大利',
	},
	{
		code: 'JM',
		countryCode: '1',
		name: 'Jamaica',
		nativeSpelling: 'Jamaica',
		de: 'Jamaika',
		fr: 'Jamaïque',
		es: 'Jamaica',
		pt: 'Jamaica',
		'zh-hant': '牙買加',
		zh: '牙买加',
	},
	{
		code: 'JP',
		countryCode: '81',
		name: 'Japan',
		nativeSpelling: 'Nippon',
		fr: 'Japon',
		de: 'Japan',
		es: 'Japón',
		pt: 'Japão',
		'zh-hant': '日本',
		zh: '日本',
	},
	{
		code: 'JO',
		countryCode: '962',
		name: 'Jordan',
		nativeSpelling: 'Al Urdun',
		de: 'Jordanien',
		fr: 'Jordanie',
		nl: 'Jordanië',
		es: 'Jordania',
		pt: 'Jordânia',
		'zh-hant': '約旦',
		zh: '约旦',
	},
	{
		code: 'KZ',
		countryCode: '7',
		name: 'Kazakhstan',
		nativeSpelling: 'Qazaqstan',
		de: 'Kasachstan',
		nl: 'Kazachstan',
		es: 'Kazajistán',
		pt: 'Casaquistão',
		'zh-hant': '哈薩克',
		zh: '哈萨克斯坦',
	},
	{
		code: 'KE',
		countryCode: '254',
		name: 'Kenya',
		nativeSpelling: 'Kenya',
		de: 'Kenia',
		es: 'Kenia',
		pt: 'Quênia',
		'zh-hant': '肯雅',
		zh: '肯尼亚',
	},
	{
		code: 'KI',
		countryCode: '686',
		name: 'Kiribati',
		nativeSpelling: 'Kiribati',
		de: 'Kiribati',
		es: 'Kiribati',
		pt: 'Quiribati',
		'zh-hant': '吉里巴斯',
		zh: '基里巴斯',
	},
	{
		code: 'KP',
		countryCode: '850',
		name: 'North Korea',
		nativeSpelling: 'Choson or Choson-minjujuui-inmin-konghwaguk',
		de: 'Korea, Demokratische Volksrepublik',
		fr: 'Corée, République populaire démocratique de',
		nl: 'Korea, Democratische Volksrepubliek',
		es: 'Corea del Norte',
		pt: 'Coreia do Norte',
		'zh-hant': '北韓',
		zh: '朝鲜',
	},
	{
		code: 'KR',
		countryCode: '82',
		name: 'South Korea',
		nativeSpelling: 'Taehan-min"guk',
		de: 'Korea, Republik',
		fr: 'Corée, République de',
		nl: 'Korea, Republiek',
		es: 'Corea del Sur',
		pt: 'Coreia do Sul',
		'zh-hant': '南韓',
		zh: '韩国',
	},
	{
		code: 'KW',
		countryCode: '965',
		name: 'Kuwait',
		nativeSpelling: 'Al Kuwayt',
		fr: 'Koweït',
		nl: 'Koeweit',
		de: 'Kuwait',
		es: 'Kuwait',
		pt: 'Kuwait',
		'zh-hant': '科威特',
		zh: '科威特',
	},
	{
		code: 'KG',
		countryCode: '996',
		name: 'Kyrgyzstan',
		nativeSpelling: 'Kyrgyz Respublikasy',
		de: 'Kirgisistan',
		fr: 'Kirghizistan',
		nl: 'Kirgistan',
		es: 'Kirguistán',
		pt: 'Quirguistão',
		'zh-hant': '吉爾吉斯',
		zh: '吉尔吉斯斯坦',
	},
	{
		code: 'LA',
		countryCode: '856',
		name: 'Laos',
		nativeSpelling: 'Sathalanalat Paxathipatai Paxaxon Lao',
		de: 'Laos, Demokratische Volksrepublik',
		fr: 'Lao (République démocratique populaire)',
		nl: 'Laos, Democratische Volksrepubliek',
		es: 'Laos',
		pt: 'Laos',
		'zh-hant': '老撾',
		zh: '老挝',
	},
	{
		code: 'LV',
		countryCode: '371',
		name: 'Latvia',
		nativeSpelling: 'Latvija',
		de: 'Lettland',
		fr: 'Lettonie',
		nl: 'Letland',
		es: 'Letonia',
		pt: 'Letônia',
		'zh-hant': '拉脱維亞',
		zh: '拉脱维亚',
	},
	{
		code: 'LB',
		countryCode: '961',
		name: 'Lebanon',
		nativeSpelling: 'Lubnan',
		de: 'Libanon',
		fr: 'Liban',
		es: 'Líbano',
		pt: 'Líbano',
		'zh-hant': '黎巴嫩',
		zh: '黎巴嫩',
	},
	{
		code: 'LS',
		countryCode: '266',
		name: 'Lesotho',
		nativeSpelling: 'Lesotho',
		de: 'Lesotho',
		es: 'Lesoto',
		pt: 'Lesoto',
		'zh-hant': '賴索托',
		zh: '莱索托',
	},
	{
		code: 'LR',
		countryCode: '231',
		name: 'Liberia',
		nativeSpelling: 'Liberia',
		de: 'Liberia',
		es: 'Liberia',
		pt: 'Libéria',
		'zh-hant': '利比里亞',
		zh: '利比里亚',
	},
	{
		code: 'LY',
		countryCode: '218',
		name: 'Libya',
		nativeSpelling: 'Libya',
		de: 'Libysch-Arabische Dschamahirija',
		fr: 'Jamahiriya arabe libyenne',
		nl: 'Libië',
		es: 'Libia',
		pt: 'Líbia',
		'zh-hant': '利比亞',
		zh: '利比亚',
	},
	{
		code: 'LI',
		countryCode: '423',
		name: 'Liechtenstein',
		nativeSpelling: 'Liechtenstein',
		de: 'Liechtenstein',
		fr: 'Liechtenstein',
		es: 'Liechtenstein',
		pt: 'Liechtenstein',
		'zh-hant': '列支敦士登',
		zh: '列支敦士登',
	},
	{
		code: 'LT',
		countryCode: '370',
		name: 'Lithuania',
		nativeSpelling: 'Lietuva',
		de: 'Litauen',
		fr: 'Lituanie',
		nl: 'Litouwen',
		es: 'Lituania',
		pt: 'Lituânia',
		'zh-hant': '立陶宛',
		zh: '立陶宛',
	},
	{
		code: 'LU',
		countryCode: '352',
		name: 'Luxembourg',
		nativeSpelling: 'Luxembourg',
		de: 'Luxemburg',
		es: 'Luxemburgo',
		pt: 'Luxemburgo',
		'zh-hant': '盧森堡',
		zh: '卢森堡',
	},
	{
		code: 'MK',
		countryCode: '389',
		name: 'Macedonia',
		nativeSpelling: 'Makedonija',
		de: 'Mazedonien, ehemalige jugoslawische Republik',
		fr: 'Macédoine, Ex-République yougoslave',
		nl: 'Macedonië, Voormalig Joegoslavische Republiek',
		es: 'Macedonia',
		pt: 'Macedônia',
		'zh-hant': '馬其頓',
		zh: '马其顿',
	},
	{
		code: 'MO',
		countryCode: '853',
		name: 'Macau SAR China',
		nativeSpelling: 'Macau Special Administrative Region',
		de: 'Macau',
		es: 'Región Administrativa Especial de Macao de la República Popular China',
		pt: 'Macau, RAE da China',
		'zh-hant': '中國澳門特別行政區',
		zh: '中国澳门特别行政区',
	},
	{
		code: 'MG',
		countryCode: '261',
		name: 'Madagascar',
		nativeSpelling: 'Madagascar',
		de: 'Madagaskar',
		nl: 'Madagaskar',
		es: 'Madagascar',
		pt: 'Madagascar',
		'zh-hant': '馬達加斯加',
		zh: '马达加斯加',
	},
	{
		code: 'MW',
		countryCode: '265',
		name: 'Malawi',
		nativeSpelling: 'Malawi',
		de: 'Malawi',
		es: 'Malaui',
		pt: 'Malawi',
		'zh-hant': '馬拉維',
		zh: '马拉维',
	},
	{
		code: 'MY',
		countryCode: '60',
		name: 'Malaysia',
		nativeSpelling: 'Malaysia',
		fr: 'Malaisie',
		nl: 'Maleisië',
		de: 'Malaysia',
		es: 'Malasia',
		pt: 'Malásia',
		'zh-hant': '馬來西亞',
		zh: '马来西亚',
	},
	{
		code: 'MV',
		countryCode: '960',
		name: 'Maldives',
		nativeSpelling: 'Dhivehi Raajje',
		de: 'Malediven',
		nl: 'Malediven',
		es: 'Maldivas',
		pt: 'Maldivas',
		'zh-hant': '馬爾代夫',
		zh: '马尔代夫',
	},
	{
		code: 'ML',
		countryCode: '223',
		name: 'Mali',
		nativeSpelling: 'Mali',
		de: 'Mali',
		es: 'Mali',
		pt: 'Mali',
		'zh-hant': '馬里',
		zh: '马里',
	},
	{
		code: 'MT',
		countryCode: '36',
		name: 'Malta',
		nativeSpelling: 'Malta',
		fr: 'Malte',
		de: 'Malta',
		es: 'Malta',
		pt: 'Malta',
		'zh-hant': '馬耳他',
		zh: '马耳他',
	},
	{
		code: 'MH',
		countryCode: '692',
		name: 'Marshall Islands',
		nativeSpelling: 'Marshall Islands',
		de: 'Marshallinseln',
		fr: 'Marshall (îles)',
		nl: 'Marshalleilanden',
		es: 'Islas Marshall',
		pt: 'Ilhas Marshall',
		'zh-hant': '馬紹爾群島',
		zh: '马绍尔群岛',
	},
	{
		code: 'MQ',
		countryCode: '596',
		name: 'Martinique',
		nativeSpelling: 'Overseas Region of Martinique',
		de: 'Martinique',
		es: 'Martinica',
		pt: 'Martinica',
		'zh-hant': '馬丁尼克',
		zh: '马提尼克',
	},
	{
		code: 'MR',
		countryCode: '222',
		name: 'Mauritania',
		nativeSpelling: 'Muritaniyah',
		de: 'Mauretanien',
		nl: 'Mauritanië',
		es: 'Mauritania',
		pt: 'Mauritânia',
		'zh-hant': '毛里塔尼亞',
		zh: '毛里塔尼亚',
	},
	{
		code: 'MU',
		countryCode: '230',
		name: 'Mauritius',
		nativeSpelling: 'Mauritius',
		de: 'Mauritius',
		es: 'Mauricio',
		pt: 'Maurício',
		'zh-hant': '毛里裘斯',
		zh: '毛里求斯',
	},
	{
		code: 'YT',
		countryCode: '262',
		name: 'Mayotte',
		nativeSpelling: 'Departmental Collectivity of Mayotte',
		de: 'Mayotte',
		es: 'Mayotte',
		pt: 'Mayotte',
		'zh-hant': '馬約特',
		zh: '马约特',
	},
	{
		code: 'FM',
		countryCode: '691',
		name: 'Federated States of Micronesia',
		nativeSpelling: 'Federated States of Micronesia',
		de: 'Mikronesien, Föderierte Staaten',
		fr: 'Micronésie, États fédérés de',
		nl: 'Micronesia, Gefedereerde Staten van',
		es: 'Micronesia',
		pt: 'Micronésia',
		'zh-hant': '密克羅尼西亞',
		zh: '密克罗尼西亚',
	},
	{
		code: 'MD',
		countryCode: '373',
		name: 'Moldova',
		nativeSpelling: 'Moldova',
		de: 'Moldau, Republik',
		fr: 'Moldavie, République de',
		nl: 'Moldavië, Republiek',
		es: 'Moldavia',
		pt: 'Moldávia',
		'zh-hant': '摩爾多瓦',
		zh: '摩尔多瓦',
	},
	{
		code: 'MC',
		countryCode: '377',
		name: 'Monaco',
		nativeSpelling: 'Monaco',
		de: 'Monaco',
		es: 'Mónaco',
		pt: 'Mônaco',
		'zh-hant': '摩納哥',
		zh: '摩纳哥',
	},
	{
		code: 'MN',
		countryCode: '976',
		name: 'Mongolia',
		nativeSpelling: 'Mongol Uls',
		de: 'Mongolei',
		fr: 'Mongolie',
		nl: 'Mongolië',
		es: 'Mongolia',
		pt: 'Mongólia',
		'zh-hant': '蒙古',
		zh: '蒙古',
	},
	{
		code: 'ME',
		countryCode: '382',
		name: 'Montenegro',
		nativeSpelling: 'Montenegro',
		de: 'Montenegro',
		fr: 'Montenegro',
		nl: 'Montenegro',
		es: 'Montenegro',
		pt: 'Montenegro',
		'zh-hant': '黑山',
		zh: '黑山',
	},
	{
		code: 'MS',
		countryCode: '1',
		name: 'Montserrat',
		nativeSpelling: 'Montserrat',
		de: 'Montserrat',
		es: 'Montserrat',
		pt: 'Montserrat',
		'zh-hant': '蒙特塞拉特',
		zh: '蒙特塞拉特',
	},
	{
		code: 'MA',
		countryCode: '212',
		name: 'Morocco',
		nativeSpelling: 'Al Maghrib',
		de: 'Marokko',
		fr: 'Maroc',
		nl: 'Marokko',
		es: 'Marruecos',
		pt: 'Marrocos',
		'zh-hant': '摩洛哥',
		zh: '摩洛哥',
	},
	{
		code: 'MZ',
		countryCode: '258',
		name: 'Mozambique',
		nativeSpelling: 'Mocambique',
		de: 'Mosambik',
		es: 'Mozambique',
		pt: 'Moçambique',
		'zh-hant': '莫桑比克',
		zh: '莫桑比克',
	},
	{
		code: 'MM',
		countryCode: '95',
		name: 'Myanmar (Burma)',
		nativeSpelling: 'Myanma Naingngandaw',
		de: 'Myanmar (Birma)',
		es: 'Myanmar [Birmania]',
		pt: 'Mianmar [Birmânia]',
		'zh-hant': '緬甸',
		zh: '缅甸',
	},
	{
		code: 'NA',
		countryCode: '264',
		name: 'Namibia',
		nativeSpelling: 'Namibia',
		fr: 'Namibie',
		nl: 'Namibië',
		de: 'Namibia',
		es: 'Namibia',
		pt: 'Namíbia',
		'zh-hant': '納米比亞',
		zh: '纳米比亚',
	},
	{
		code: 'NR',
		countryCode: '674',
		name: 'Nauru',
		nativeSpelling: 'Nauru',
		de: 'Nauru',
		es: 'Nauru',
		pt: 'Nauru',
		'zh-hant': '瑙魯',
		zh: '瑙鲁',
	},
	{
		code: 'NP',
		countryCode: '977',
		name: 'Nepal',
		nativeSpelling: 'Nepal',
		de: 'Nepal',
		es: 'Nepal',
		pt: 'Nepal',
		'zh-hant': '尼泊爾',
		zh: '尼泊尔',
	},
	{
		code: 'NL',
		countryCode: '31',
		name: 'Netherlands',
		nativeSpelling: 'Nederland',
		de: 'Niederlande',
		fr: 'Pays-Bas',
		nl: 'Nederland',
		es: 'Países Bajos',
		pt: 'Holanda',
		'zh-hant': '荷蘭',
		zh: '荷兰',
	},
	{
		code: 'AN',
		countryCode: '599',
		name: 'Netherlands Antilles',
		nativeSpelling: 'Netherlands Antilles',
		de: 'Niederländische Antillen',
		fr: 'Antilles néerlandaises',
		nl: 'Nederlandse Antillen',
		es: 'Antillas Neerlandesas',
		pt: 'Antilhas Holandesas',
		'zh-hant': '荷屬安的列斯',
		zh: '荷属安的列斯',
	},
	{
		code: 'NC',
		countryCode: '687',
		name: 'New Caledonia',
		nativeSpelling: 'New Caledonia',
		de: 'Neukaledonien',
		fr: 'Nouvelle-Calédonie',
		nl: 'Nieuw-Caledonië',
		es: 'Nueva Caledonia',
		pt: 'Nova Caledônia',
		'zh-hant': '新喀里多尼亞',
		zh: '新喀里多尼亚',
	},
	{
		code: 'NZ',
		countryCode: '64',
		name: 'New Zealand',
		nativeSpelling: 'New Zealand',
		de: 'Neuseeland',
		fr: 'Nouvelle-Zélande',
		nl: 'Nieuw-Zeeland',
		es: 'Nueva Zelanda',
		pt: 'Nova Zelândia',
		'zh-hant': '紐西蘭',
		zh: '新西兰',
	},
	{
		code: 'NI',
		countryCode: '505',
		name: 'Nicaragua',
		nativeSpelling: 'Nicaragua',
		de: 'Nicaragua',
		es: 'Nicaragua',
		pt: 'Nicarágua',
		'zh-hant': '尼加拉瓜',
		zh: '尼加拉瓜',
	},
	{
		code: 'NE',
		countryCode: '227',
		name: 'Niger',
		nativeSpelling: 'Niger',
		de: 'Niger',
		es: 'Níger',
		pt: 'Níger',
		'zh-hant': '尼日爾',
		zh: '尼日尔',
	},
	{
		code: 'NG',
		countryCode: '234',
		name: 'Nigeria',
		nativeSpelling: 'Nigeria',
		de: 'Nigeria',
		es: 'Nigeria',
		pt: 'Nigéria',
		'zh-hant': '尼日利亞',
		zh: '尼日利亚',
	},
	{
		code: 'NO',
		countryCode: '47',
		name: 'Norway',
		nativeSpelling: 'Norge',
		de: 'Norwegen',
		fr: 'Norvège',
		nl: 'Noorwegen',
		es: 'Noruega',
		pt: 'Noruega',
		'zh-hant': '挪威',
		zh: '挪威',
	},
	{
		code: 'NU',
		countryCode: '683',
		name: 'Niue',
		nativeSpelling: 'Niue',
		de: 'Niue',
		es: 'Isla Niue',
		pt: 'Niue',
		'zh-hant': '紐埃島',
		zh: '纽埃',
	},
	{
		code: 'OM',
		countryCode: '968',
		name: 'Oman',
		nativeSpelling: 'Uman',
		de: 'Oman',
		es: 'Omán',
		pt: 'Omã',
		'zh-hant': '阿曼',
		zh: '阿曼',
	},
	{
		code: 'PK',
		countryCode: '92',
		name: 'Pakistan',
		nativeSpelling: 'Pakistan',
		de: 'Pakistan',
		es: 'Pakistán',
		pt: 'Paquistão',
		'zh-hant': '巴基斯坦',
		zh: '巴基斯坦',
	},
	{
		code: 'PW',
		countryCode: '680',
		name: 'Palau',
		nativeSpelling: 'Belau',
		de: 'Palau',
		es: 'Palau',
		pt: 'Palau',
		'zh-hant': '帛琉',
		zh: '帕劳',
	},
	{
		code: 'PA',
		countryCode: '507',
		name: 'Panama',
		nativeSpelling: 'Panama',
		de: 'Panama',
		es: 'Panamá',
		pt: 'Panamá',
		'zh-hant': '巴拿馬',
		zh: '巴拿马',
	},
	{
		code: 'PG',
		countryCode: '675',
		name: 'Papua New Guinea',
		nativeSpelling: 'Papua New Guinea',
		de: 'Papua-Neuguinea',
		fr: 'Papouasie-Nouvelle-Guinée',
		nl: 'Papoea-Nieuw-Guinea',
		es: 'Papúa Nueva Guinea',
		pt: 'Papua-Nova Guiné',
		'zh-hant': '巴布亞新幾內亞',
		zh: '巴布亚新几内亚',
	},
	{
		code: 'PY',
		countryCode: '595',
		name: 'Paraguay',
		nativeSpelling: 'Paraguay',
		de: 'Paraguay',
		es: 'Paraguay',
		pt: 'Paraguai',
		'zh-hant': '巴拉圭',
		zh: '巴拉圭',
	},
	{
		code: 'PE',
		countryCode: '51',
		name: 'Peru',
		nativeSpelling: 'Peru',
		fr: 'Pérou',
		de: 'Peru',
		es: 'Perú',
		pt: 'Peru',
		'zh-hant': '秘魯',
		zh: '秘鲁',
	},
	{
		code: 'PH',
		countryCode: '63',
		name: 'Philippines',
		nativeSpelling: 'Pilipinas',
		de: 'Philippinen',
		nl: 'Filipijnen',
		es: 'Filipinas',
		pt: 'Filipinas',
		'zh-hant': '菲律賓',
		zh: '菲律宾',
	},
	{
		code: 'PL',
		countryCode: '48',
		name: 'Poland',
		nativeSpelling: 'Polska',
		de: 'Polen',
		fr: 'Pologne',
		nl: 'Polen',
		es: 'Polonia',
		pt: 'Polônia',
		'zh-hant': '波蘭',
		zh: '波兰',
	},
	{
		code: 'PN',
		countryCode: '64',
		name: 'Pitcairn Islands',
		nativeSpelling: 'Pitcairn Islands',
		de: 'Pitcairninseln',
		fr: 'Pitcairn (Île)',
		nl: 'Pitcairneilanden',
		es: 'Islas Pitcairn',
		pt: 'Ilhas Pitcairn',
		'zh-hant': '皮特凱恩島',
		zh: '皮特凯恩群岛',
	},
	{
		code: 'PT',
		countryCode: '351',
		name: 'Portugal',
		nativeSpelling: 'Portugal',
		de: 'Portugal',
		es: 'Portugal',
		pt: 'Portugal',
		'zh-hant': '葡萄牙',
		zh: '葡萄牙',
	},
	{
		code: 'QA',
		countryCode: '974',
		name: 'Qatar',
		nativeSpelling: 'Qatar',
		de: 'Katar',
		es: 'Qatar',
		pt: 'Catar',
		'zh-hant': '卡塔爾',
		zh: '卡塔尔',
	},
	{
		code: 'RE',
		countryCode: '262',
		name: 'Reunion',
		nativeSpelling: 'Overseas Region of Reunion',
		de: 'Réunion',
		fr: 'Réunion (Île de la)',
		es: 'Reunión',
		pt: 'Reunião',
		'zh-hant': '留尼旺',
		zh: '留尼汪',
	},
	{
		code: 'RO',
		countryCode: '40',
		name: 'Romania',
		nativeSpelling: 'Romania',
		de: 'Rumänien',
		fr: 'Roumanie',
		nl: 'Roemenië',
		es: 'Rumanía',
		pt: 'Romênia',
		'zh-hant': '羅馬尼亞',
		zh: '罗马尼亚',
	},
	{
		code: 'RU',
		countryCode: '7',
		name: 'Russia',
		nativeSpelling: 'Rossiya',
		de: 'Russische Föderation',
		fr: 'Fédération de Russie',
		nl: 'Russische Federatie',
		es: 'Rusia',
		pt: 'Rússia',
		'zh-hant': '俄羅斯',
		zh: '俄罗斯',
	},
	{
		code: 'RW',
		countryCode: '250',
		name: 'Rwanda',
		nativeSpelling: 'Rwanda',
		de: 'Ruanda',
		es: 'Ruanda',
		pt: 'Ruanda',
		'zh-hant': '盧旺達',
		zh: '卢旺达',
	},
	{
		code: 'VC',
		countryCode: '1',
		name: 'Saint Vincent and the Grenadines',
		nativeSpelling: 'Saint Vincent and the Grenadines',
		de: 'St. Vincent und die Grenadinen',
		fr: 'Saint-Vincent-et-les-Grenadines',
		nl: 'Saint Vincent en de Grenadines',
		es: 'San Vicente y las Granadinas',
		pt: 'São Vicente e Granadinas',
		'zh-hant': '聖文森特和格林納丁斯',
		zh: '圣文森特和格林纳丁斯',
	},
	{
		code: 'KN',
		countryCode: '1',
		name: 'Saint Kitts and Nevis',
		nativeSpelling: 'Saint Kitts and Nevis',
		de: 'St. Kitts und Nevis',
		fr: 'Saint-Christophe-et-Niévès',
		nl: 'Saint Kitts en Nevis',
		es: 'San Cristóbal y Nieves',
		pt: 'São Cristovão e Nevis',
		'zh-hant': '聖基茨和尼維斯',
		zh: '圣基茨和尼维斯',
	},
	{
		code: 'LC',
		countryCode: '1',
		name: 'Saint Lucia',
		nativeSpelling: 'Saint Lucia',
		de: 'St. Lucia',
		fr: 'Sainte Lucie',
		es: 'Santa Lucía',
		pt: 'Santa Lúcia',
		'zh-hant': '聖盧西亞',
		zh: '圣卢西亚',
	},
	{
		code: 'WS',
		countryCode: '685',
		name: 'Samoa',
		nativeSpelling: 'Samoa',
		de: 'Samoa',
		es: 'Samoa',
		pt: 'Samoa',
		'zh-hant': '薩摩亞',
		zh: '萨摩亚',
	},
	{
		code: 'SM',
		countryCode: '378',
		name: 'San Marino',
		nativeSpelling: 'San Marino',
		fr: 'Saint-Marin',
		de: 'San Marino',
		es: 'San Marino',
		pt: 'San Marino',
		'zh-hant': '聖馬利諾',
		zh: '圣马力诺',
	},
	{
		code: 'ST',
		countryCode: '239',
		name: 'Sao Tome and Principe',
		nativeSpelling: 'Sao Tome e Principe',
		de: 'São Tomé und Príncipe',
		fr: 'Sao Tomé-et-Principe',
		nl: 'Sao Tomé en Principe',
		es: 'Santo Tomé y Príncipe',
		pt: 'São Tomé e Príncipe',
		'zh-hant': '聖多美和普林西比',
		zh: '圣多美和普林西比',
	},
	{
		code: 'SA',
		countryCode: '966',
		name: 'Saudi Arabia',
		nativeSpelling: 'Al Arabiyah as Suudiyah',
		de: 'Saudi-Arabien',
		fr: 'Arabie saoudite',
		nl: 'Saoedi-Arabië',
		es: 'Arabia Saudí',
		pt: 'Arábia Saudita',
		'zh-hant': '沙地阿拉伯',
		zh: '沙特阿拉伯',
	},
	{
		code: 'SN',
		countryCode: '221',
		name: 'Senegal',
		nativeSpelling: 'Senegal',
		fr: 'Sénégal',
		de: 'Senegal',
		es: 'Senegal',
		pt: 'Senegal',
		'zh-hant': '塞內加爾',
		zh: '塞内加尔',
	},
	{
		code: 'RS',
		countryCode: '381',
		name: 'Serbia',
		nativeSpelling: 'Srbija',
		de: 'Serbia',
		fr: 'Serbia',
		nl: 'Serbia',
		es: 'Serbia',
		pt: 'Sérvia',
		'zh-hant': '塞爾維亞',
		zh: '塞尔维亚',
	},
	{
		code: 'SC',
		countryCode: '248',
		name: 'Seychelles',
		nativeSpelling: 'Seychelles',
		de: 'Seychellen',
		nl: 'Seychellen',
		es: 'Seychelles',
		pt: 'Seychelles',
		'zh-hant': '塞舌爾',
		zh: '塞舌尔',
	},
	{
		code: 'SL',
		countryCode: '232',
		name: 'Sierra Leone',
		nativeSpelling: 'Sierra Leone',
		de: 'Sierra Leone',
		es: 'Sierra Leona',
		pt: 'Serra Leoa',
		'zh-hant': '塞拉利昂',
		zh: '塞拉利昂',
	},
	{
		code: 'SG',
		countryCode: '65',
		name: 'Singapore',
		nativeSpelling: 'Singapore',
		de: 'Singapur',
		fr: 'Singapour',
		es: 'Singapur',
		pt: 'Cingapura',
		'zh-hant': '新加坡',
		zh: '新加坡',
	},
	{
		code: 'SK',
		countryCode: '421',
		name: 'Slovakia',
		nativeSpelling: 'Slovensko',
		de: 'Slowakei (Slowakische Republik)',
		fr: 'Slovaquie (République slovaque)',
		nl: 'Slowakije (Slowaakse Republiek)',
		es: 'Eslovaquia',
		pt: 'Eslováquia',
		'zh-hant': '斯洛伐克',
		zh: '斯洛伐克',
	},
	{
		code: 'SI',
		countryCode: '386',
		name: 'Slovenia',
		nativeSpelling: 'Slovenija',
		de: 'Slowenien',
		fr: 'Slovénie',
		nl: 'Slovenië',
		es: 'Eslovenia',
		pt: 'Eslovênia',
		'zh-hant': '斯洛文尼亞',
		zh: '斯洛文尼亚',
	},
	{
		code: 'SB',
		countryCode: '677',
		name: 'Solomon Islands',
		nativeSpelling: 'Solomon Islands',
		de: 'Salomonen',
		fr: 'Salomon (îles)',
		nl: 'Salomonseilanden',
		es: 'Islas Salomón',
		pt: 'Ilhas Salomão',
		'zh-hant': '所羅門群島',
		zh: '所罗门群岛',
	},
	{
		code: 'SO',
		countryCode: '252',
		name: 'Somalia',
		nativeSpelling: 'Somalia',
		nl: 'Somalië',
		de: 'Somalia',
		es: 'Somalia',
		pt: 'Somália',
		'zh-hant': '索馬里',
		zh: '索马里',
	},
	{
		code: 'ZA',
		countryCode: '27',
		name: 'South Africa',
		nativeSpelling: 'South Africa',
		de: 'Südafrika',
		fr: 'Afrique du Sud',
		nl: 'Zuid-Afrika',
		es: 'Sudáfrica',
		pt: 'África do Sul',
		'zh-hant': '南非',
		zh: '南非',
	},
	{
		code: 'ES',
		countryCode: '34',
		name: 'Spain',
		nativeSpelling: 'Espana',
		de: 'Spanien',
		fr: 'Espagne',
		nl: 'Spanje',
		es: 'España',
		pt: 'Espanha',
		'zh-hant': '西班牙',
		zh: '西班牙',
	},
	{
		code: 'LK',
		countryCode: '94',
		name: 'Sri Lanka',
		nativeSpelling: 'Sri Lanka',
		nl: 'Sri Lanka',
		de: 'Sri Lanka',
		es: 'Sri Lanka',
		pt: 'Sri Lanka',
		'zh-hant': '斯里蘭卡',
		zh: '斯里兰卡',
	},
	{
		code: 'SD',
		countryCode: '294',
		name: 'Sudan',
		nativeSpelling: 'As-Sudan',
		de: 'Sudan',
		es: 'Sudán',
		pt: 'Sudão',
		'zh-hant': '蘇丹',
		zh: '苏丹',
	},
	{
		code: 'SR',
		countryCode: '597',
		name: 'Suriname',
		nativeSpelling: 'Suriname',
		de: 'Suriname',
		es: 'Surinam',
		pt: 'Suriname',
		'zh-hant': '蘇里南',
		zh: '苏里南',
	},
	{
		code: 'SZ',
		countryCode: '268',
		name: 'Swaziland',
		nativeSpelling: 'Swaziland',
		de: 'Swasiland',
		es: 'Suazilandia',
		pt: 'Suazilândia',
		'zh-hant': '斯威士蘭',
		zh: '斯威士兰',
	},
	{
		code: 'SE',
		countryCode: '46',
		name: 'Sweden',
		nativeSpelling: 'Sverige',
		de: 'Schweden',
		nl: 'Zweden',
		es: 'Suecia',
		pt: 'Suécia',
		'zh-hant': '瑞典',
		zh: '瑞典',
	},
	{
		code: 'PM',
		countryCode: '508',
		name: 'Saint Pierre and Miquelon',
		nativeSpelling: 'Territorial Collectivity of Saint Pierre and Miquelon',
		de: 'St. Pierre und Miquelon',
		fr: 'Saint-Pierre-et-Miquelon',
		es: 'San Pedro y Miquelón',
		pt: 'Saint Pierre e Miquelon',
		'zh-hant': '聖皮埃與密克隆群島',
		zh: '圣皮埃尔和密克隆群岛',
	},
	{
		code: 'SJ',
		countryCode: '47',
		name: 'Svalbard and Jan Mayen',
		nativeSpelling: 'Svalbard and Jan Mayen',
		de: 'Svalbard und Jan Mayen',
		fr: 'Svalbard et Jan Mayen (Îles de)',
		nl: 'Spitsbergen en Jan Mayen',
		es: 'Svalbard y Jan Mayen',
		pt: 'Svalbard e Jan Mayen',
		'zh-hant': '斯瓦爾巴特群島及揚馬延島',
		zh: '斯瓦尔巴和扬马延',
	},
	{
		code: 'SH',
		countryCode: '290',
		name: 'Saint Helena',
		nativeSpelling: 'Saint Helena',
		de: 'St. Helena',
		fr: 'Sainte-Hélène',
		nl: 'Sint-Helena',
		es: 'Santa Elena',
		pt: 'Santa Helena',
		'zh-hant': '聖赫勒拿島',
		zh: '圣赫勒拿',
	},
	{
		code: 'CH',
		countryCode: '41',
		name: 'Switzerland',
		nativeSpelling: 'Schweiz (German), Suisse (French), Svizzera (Italian)',
		de: 'Schweiz',
		fr: 'Suisse',
		it: 'Svizzera',
		nl: 'Zwitserland',
		es: 'Suiza',
		pt: 'Suíça',
		'zh-hant': '瑞士',
		zh: '瑞士',
	},
	{
		code: 'SY',
		countryCode: '963',
		name: 'Syria',
		nativeSpelling: 'Suriyah',
		de: 'Syrien, Arabische Republik',
		nl: 'Syrië, Arabische Republiek',
		es: 'Siria',
		pt: 'Síria',
		'zh-hant': '敘利亞',
		zh: '叙利亚',
	},
	{
		code: 'TW',
		countryCode: '886',
		name: 'Taiwan',
		nativeSpelling: 'T"ai-wan',
		de: 'Taiwan',
		es: 'Taiwán',
		pt: 'Taiwan',
		'zh-hant': '台灣',
		zh: '台湾',
	},
	{
		code: 'TJ',
		countryCode: '992',
		name: 'Tajikistan',
		nativeSpelling: 'Jumhurii Tojikistan',
		de: 'Tadschikistan',
		fr: 'Tadjikistan',
		nl: 'Tadzjikistan',
		es: 'Tayikistán',
		pt: 'Tadjiquistão',
		'zh-hant': '塔吉克',
		zh: '塔吉克斯坦',
	},
	{
		code: 'TZ',
		countryCode: '255',
		name: 'Tanzania',
		nativeSpelling: 'Tanzania',
		de: 'Tansania, Vereinigte Republik',
		fr: 'Tanzanie, République unie de',
		nl: 'Tanzania, Verenigde Republiek',
		es: 'Tanzania',
		pt: 'Tanzânia',
		'zh-hant': '坦桑尼亞',
		zh: '坦桑尼亚',
	},
	{
		code: 'TH',
		countryCode: '66',
		name: 'Thailand',
		nativeSpelling: 'Muang Thai',
		fr: 'Thaïlande',
		de: 'Thailand',
		es: 'Tailandia',
		pt: 'Tailândia',
		'zh-hant': '泰國',
		zh: '泰国',
	},
	{
		code: 'TG',
		countryCode: '228',
		name: 'Togo',
		nativeSpelling: 'Togo',
		de: 'Togo',
		es: 'Togo',
		pt: 'Togo',
		'zh-hant': '多哥共和國',
		zh: '多哥',
	},
	{
		code: 'TO',
		countryCode: '676',
		name: 'Tonga',
		nativeSpelling: 'Tonga',
		de: 'Tonga',
		es: 'Tonga',
		pt: 'Tonga',
		'zh-hant': '湯加',
		zh: '汤加',
	},
	{
		code: 'TK',
		countryCode: '690',
		name: 'Tokelau',
		nativeSpelling: 'Tokelau',
		nl: 'Tokelau-eilanden',
		de: 'Tokelau',
		es: 'Tokelau',
		pt: 'Tokelau',
		'zh-hant': '托克勞群島',
		zh: '托克劳',
	},
	{
		code: 'TT',
		countryCode: '1',
		name: 'Trinidad and Tobago',
		nativeSpelling: 'Trinidad and Tobago',
		de: 'Trinidad und Tobago',
		fr: 'Trinité-et-Tobago',
		nl: 'Trinidad en Tobago',
		es: 'Trinidad y Tobago',
		pt: 'Trinidad e Tobago',
		'zh-hant': '千里達和多巴哥',
		zh: '特立尼达和多巴哥',
	},
	{
		code: 'TN',
		countryCode: '216',
		name: 'Tunisia',
		nativeSpelling: 'Tunis',
		de: 'Tunesien',
		fr: 'Tunisie',
		nl: 'Tunesië',
		es: 'Túnez',
		pt: 'Tunísia',
		'zh-hant': '突尼西亞',
		zh: '突尼斯',
	},
	{
		code: 'TR',
		countryCode: '90',
		name: 'Turkey',
		nativeSpelling: 'Turkiye',
		de: 'Türkei',
		fr: 'Turquie',
		nl: 'Turkije',
		es: 'Turquía',
		pt: 'Turquia',
		'zh-hant': '土耳其',
		zh: '土耳其',
	},
	{
		code: 'TM',
		countryCode: '993',
		name: 'Turkmenistan',
		nativeSpelling: 'Turkmenistan',
		fr: 'Turkménistan',
		de: 'Turkmenistan',
		es: 'Turkmenistán',
		pt: 'Turcomenistão',
		'zh-hant': '土庫曼',
		zh: '土库曼斯坦',
	},
	{
		code: 'TV',
		countryCode: '688',
		name: 'Tuvalu',
		nativeSpelling: 'Tuvalu',
		de: 'Tuvalu',
		es: 'Tuvalu',
		pt: 'Tuvalu',
		'zh-hant': '圖瓦盧',
		zh: '图瓦卢',
	},
	{
		code: 'UG',
		countryCode: '256',
		name: 'Uganda',
		nativeSpelling: 'Uganda',
		fr: 'Ouganda',
		de: 'Uganda',
		es: 'Uganda',
		pt: 'Uganda',
		'zh-hant': '烏干達',
		zh: '乌干达',
	},
	{
		code: 'TC',
		countryCode: '1',
		name: 'Turks and Caicos Islands',
		nativeSpelling: 'Turks and Caicos Islands',
		de: 'Turks- und Caicosinseln',
		fr: 'Turks et Caicos (îles)',
		nl: 'Turks-en Caicoseilanden',
		es: 'Islas Turcas y Caicos',
		pt: 'Ilhas Turks e Caicos',
		'zh-hant': '特克斯和凱科斯群島',
		zh: '特克斯和凯科斯群岛',
	},
	{
		code: 'UA',
		countryCode: '380',
		name: 'Ukraine',
		nativeSpelling: 'Ukrayina',
		nl: 'Oekraïne',
		de: 'Ukraine',
		es: 'Ucrania',
		pt: 'Ucrânia',
		'zh-hant': '烏克蘭',
		zh: '乌克兰',
	},
	{
		code: 'AE',
		countryCode: '971',
		name: 'United Arab Emirates',
		nativeSpelling: 'Al Imarat al Arabiyah al Muttahidah',
		de: 'Vereinigte Arabische Emirate',
		fr: 'Émirats arabes unis',
		nl: 'Verenigde Arabische Emiraten',
		es: 'Emiratos Árabes Unidos',
		pt: 'Emirados Árabes Unidos',
		'zh-hant': '阿拉伯聯合酋長國',
		zh: '阿拉伯联合酋长国',
	},
	{
		code: 'UY',
		countryCode: '598',
		name: 'Uruguay',
		nativeSpelling: 'Uruguay',
		de: 'Uruguay',
		es: 'Uruguay',
		pt: 'Uruguai',
		'zh-hant': '烏拉圭',
		zh: '乌拉圭',
	},
	{
		code: 'UZ',
		countryCode: '998',
		name: 'Uzbekistan',
		nativeSpelling: 'Uzbekiston Respublikasi',
		de: 'Usbekistan',
		fr: 'Ouzbékistan',
		nl: 'Oezbekistan',
		es: 'Uzbekistán',
		pt: 'Uzbequistão',
		'zh-hant': '烏茲別克',
		zh: '乌兹别克斯坦',
	},
	{
		code: 'VU',
		countryCode: '678',
		name: 'Vanuatu',
		nativeSpelling: 'Vanuatu',
		de: 'Vanuatu',
		es: 'Vanuatu',
		pt: 'Vanuatu',
		'zh-hant': '瓦努阿圖',
		zh: '瓦努阿图',
	},
	{
		code: 'VA',
		countryCode: '379',
		name: 'Vatican City',
		nativeSpelling: 'Santa Sede (Citta del Vaticano)',
		de: 'Heiliger Stuhl (die Vatikanstadt)',
		fr: 'Saint-Siège (Cité du Vatican)',
		nl: 'Heilige Stoel (Vaticaanstad)',
		es: 'Ciudad del Vaticano',
		pt: 'Vaticano',
		'zh-hant': '梵蒂岡',
		zh: '梵蒂冈',
	},
	{
		code: 'VE',
		countryCode: '58',
		name: 'Venezuela',
		nativeSpelling: 'Venezuela',
		de: 'Venezuela',
		es: 'Venezuela',
		pt: 'Venezuela',
		'zh-hant': '委內瑞拉',
		zh: '委内瑞拉',
	},
	{
		code: 'VN',
		countryCode: '84',
		name: 'Vietnam',
		nativeSpelling: 'Viet Nam',
		de: 'Vietnam',
		es: 'Vietnam',
		pt: 'Vietnã',
		'zh-hant': '越南',
		zh: '越南',
	},
	{
		code: 'YE',
		countryCode: '967',
		name: 'Yemen',
		nativeSpelling: 'Al Yaman',
		de: 'Jemen',
		nl: 'Jemen',
		es: 'Yemen',
		pt: 'Iêmen',
		'zh-hant': '也門',
		zh: '也门',
	},
	{
		code: 'ZM',
		countryCode: '260',
		name: 'Zambia',
		nativeSpelling: 'Zambia',
		de: 'Sambia',
		fr: 'Zambie',
		es: 'Zambia',
		pt: 'Zâmbia',
		'zh-hant': '贊比亞',
		zh: '赞比亚',
	},
	{
		code: 'ZW',
		countryCode: '263',
		name: 'Zimbabwe',
		nativeSpelling: 'Zimbabwe',
		de: 'Simbabwe',
		fr: 'Zimbabwe',
		es: 'Zimbabue',
		pt: 'Zimbábue',
		'zh-hant': '津巴布韋',
		zh: '津巴布韦',
	},
];

export const REGIONS = {
	AU: [
		{
			value: 'ACT',
			label: 'Australia Capital Territory',
		},
		{
			value: 'NSW',
			label: 'New South Wales',
		},
		{
			value: 'NT',
			label: 'Northern Territory',
		},
		{
			value: 'QLD',
			label: 'Queensland',
		},
		{
			value: 'SA',
			label: 'South Australia',
		},
		{
			value: 'TAS',
			label: 'Tasmania',
		},
		{
			value: 'VIC',
			label: 'Victoria',
		},
		{
			value: 'WA',
			label: 'Western Australia',
		},
	],
	CA: [
		{
			value: 'AB',
			label: 'Alberta',
		},
		{
			value: 'BC',
			label: 'British Columbia',
			en: 'British Columbia',
			fr: 'Colombie-Britannique',
		},
		{
			value: 'MB',
			label: 'Manitoba',
		},
		{
			value: 'NB',
			label: 'New Brunswick',
			en: 'New Brunswick',
			fr: 'Nouveau-Brunswick',
		},
		{
			value: 'NL',
			label: 'Newfoundland and Labrador',
			en: 'Newfoundland and Labrador',
			fr: 'Terre-Neuve-et-Labrador',
		},
		{
			value: 'NT',
			label: 'Northwest Territories',
			en: 'Northwest Territories',
			fr: 'Territoires du Nord-Ouest',
		},
		{
			value: 'NS',
			label: 'Nova Scotia',
			en: 'Nova Scotia',
			fr: 'Nouvelle-Écosse',
		},
		{
			value: 'NU',
			label: 'Nunavut',
		},
		{
			value: 'ON',
			label: 'Ontario',
		},
		{
			value: 'PE',
			label: 'Prince Edward Island',
			en: 'Prince Edward Island',
			fr: 'Nouvelle-Écosse',
		},
		{
			value: 'QC',
			label: 'Québec',
		},
		{
			value: 'SK',
			label: 'Saskatchewan',
		},
		{
			value: 'YT',
			label: 'Yukon',
		},
	],
	MX: [
		{
			value: 'AG',
			label: 'Aguascalientes',
		},
		{
			value: 'BC',
			label: 'Baja California',
		},
		{
			value: 'BS',
			label: 'Baja California Sur',
		},
		{
			value: 'CM',
			label: 'Campeche',
		},
		{
			value: 'CS',
			label: 'Chiapas',
		},
		{
			value: 'CH',
			label: 'Chihuahua',
		},
		{
			value: 'CO',
			label: 'Coahuila',
		},
		{
			value: 'CL',
			label: 'Colima',
		},
		{
			value: 'DF',
			label: 'Federal District',
		},
		{
			value: 'DG',
			label: 'Durango',
		},
		{
			value: 'GT',
			label: 'Guanajuato',
		},
		{
			value: 'GR',
			label: 'Guerrero',
		},
		{
			value: 'HG',
			label: 'Hidalgo',
		},
		{
			value: 'JA',
			label: 'Jalisco',
		},
		{
			value: 'ME',
			label: 'Mexico State',
		},
		{
			value: 'MI',
			label: 'Michoacán',
		},
		{
			value: 'MO',
			label: 'Morelos',
		},
		{
			value: 'NA',
			label: 'Nayarit',
		},
		{
			value: 'NL',
			label: 'Nuevo León',
		},
		{
			value: 'OA',
			label: 'Oaxaca',
		},
		{
			value: 'PB',
			label: 'Puebla',
		},
		{
			value: 'QE',
			label: 'Querétaro',
		},
		{
			value: 'QR',
			label: 'Quintana Roo',
		},
		{
			value: 'SL',
			label: 'San Luis Potosí',
		},
		{
			value: 'SI',
			label: 'Sinaloa',
		},
		{
			value: 'SO',
			label: 'Sonora',
		},
		{
			value: 'TB',
			label: 'Tabasco',
		},
		{
			value: 'TM',
			label: 'Tamaulipas',
		},
		{
			value: 'TL',
			label: 'Tlaxcala',
		},
		{
			value: 'VE',
			label: 'Veracruz',
		},
		{
			value: 'YU',
			label: 'Yucatán',
		},
		{
			value: 'ZA',
			label: 'Zacatecas',
		},
	],
	US: [
		{
			value: 'AL',
			label: 'Alabama',
		},
		{
			value: 'AK',
			label: 'Alaska',
		},
		{
			value: 'AZ',
			label: 'Arizona',
		},
		{
			value: 'AR',
			label: 'Arkansas',
		},
		{
			value: 'CA',
			label: 'California',
		},
		{
			value: 'CO',
			label: 'Colorado',
		},
		{
			value: 'CT',
			label: 'Connecticut',
		},
		{
			value: 'DC',
			label: 'District of Columbia',
		},
		{
			value: 'DE',
			label: 'Delaware',
		},
		{
			value: 'FL',
			label: 'Florida',
		},
		{
			value: 'GA',
			label: 'Georgia',
		},
		{
			value: 'GU',
			label: 'Guam',
		},
		{
			value: 'HI',
			label: 'Hawaii',
		},
		{
			value: 'ID',
			label: 'Idaho',
		},
		{
			value: 'IL',
			label: 'Illinois',
		},
		{
			value: 'IN',
			label: 'Indiana',
		},
		{
			value: 'IA',
			label: 'Iowa',
		},
		{
			value: 'KS',
			label: 'Kansas',
		},
		{
			value: 'KY',
			label: 'Kentucky',
		},
		{
			value: 'LA',
			label: 'Louisiana',
		},
		{
			value: 'ME',
			label: 'Maine',
		},
		{
			value: 'MD',
			label: 'Maryland',
		},
		{
			value: 'MA',
			label: 'Massachusetts',
		},
		{
			value: 'MI',
			label: 'Michigan',
		},
		{
			value: 'MN',
			label: 'Minnesota',
		},
		{
			value: 'MS',
			label: 'Mississippi',
		},
		{
			value: 'MO',
			label: 'Missouri',
		},
		{
			value: 'MT',
			label: 'Montana',
		},
		{
			value: 'NE',
			label: 'Nebraska',
		},
		{
			value: 'NV',
			label: 'Nevada',
		},
		{
			value: 'NH',
			label: 'New Hampshire',
		},
		{
			value: 'NJ',
			label: 'New Jersey',
		},
		{
			value: 'NM',
			label: 'New Mexico',
		},
		{
			value: 'NY',
			label: 'New York',
		},
		{
			value: 'NC',
			label: 'North Carolina',
		},
		{
			value: 'ND',
			label: 'North Dakota',
		},
		{
			value: 'OH',
			label: 'Ohio',
		},
		{
			value: 'OK',
			label: 'Oklahoma',
		},
		{
			value: 'OR',
			label: 'Oregon',
		},
		{
			value: 'PA',
			label: 'Pennsylvania',
		},
		{
			value: 'PR',
			label: 'Puerto Rico',
		},
		{
			value: 'RI',
			label: 'Rhode Island',
		},
		{
			value: 'SC',
			label: 'South Carolina',
		},
		{
			value: 'SD',
			label: 'South Dakota',
		},
		{
			value: 'TN',
			label: 'Tennessee',
		},
		{
			value: 'TX',
			label: 'Texas',
		},
		{
			value: 'UT',
			label: 'Utah',
		},
		{
			value: 'VT',
			label: 'Vermont',
		},
		{
			value: 'VA',
			label: 'Virginia',
		},
		{
			value: 'WA',
			label: 'Washington',
		},
		{
			value: 'WV',
			label: 'West Virginia',
		},
		{
			value: 'WI',
			label: 'Wisconsin',
		},
		{
			value: 'WY',
			label: 'Wyoming',
		},
	],
};
